import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import "./sass/main.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// Mouse particles
import MouseParticles from "react-mouse-particles";

ReactDOM.render(
  // <React.StrictMode>
  <Fragment>
    <App />
    <MouseParticles
      g={1}
      color="random"
      cull="btn-primary,btn-secondary,app-bar,btn"
      level={6}
    />
    
  </Fragment>,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
